import { Dispatch } from 'redux';
import backend from '../../../apis/backend';
import { ReduxState } from '../../state';
import { 
  getQueriedItemsSuccess, 
  getQueriedItemsFailure,
  setItemsQuerying,
  updateItemsQuery
} from '../actions';

// Action to fetch queried items
export const fetchQueriedItems = (more: boolean = false) => {
  return async (dispatch: Dispatch, getState: () => ReduxState) => {
    try {
      // Get the loginToken from the Redux state
      const { queriedItems, itemsQuery } = getState().page;
      const { search, currentPage } = itemsQuery;
      let fetchedQueriedItems: any[] = [];
      dispatch(setItemsQuerying(true));
      // Construct the URL with query parameters
      let url = `/marketplace-service/api/v1/pages-items?search=${search}`;
      if (more && currentPage) {
        const nextPage = currentPage + 1
        url += `&page=${nextPage}`
      }
      if (itemsQuery.freeDelivery) {
        url += `&freeDelivery=1`;
      }
      const response = await backend.get(url);

      if (response.status === 200) {
        const { currentPage, itemsPerPage, totalPages, totalItems } = response.data;
        const details = { 
          ...itemsQuery,
          totalItems, currentPage, totalPages, itemsPerPage
         }
         if (more) {
          fetchedQueriedItems = [...queriedItems].concat(response.data.items)
        } else {
          fetchedQueriedItems = response.data.items
        }
        dispatch(setItemsQuerying(false));
        dispatch(getQueriedItemsSuccess(fetchedQueriedItems));
        dispatch(updateItemsQuery(details))
      } else {
        dispatch(setItemsQuerying(false));
        dispatch(getQueriedItemsFailure('Failed to fetch business items.'));
      }
    } catch (error) {
      console.error('Error fetching business items:', error);
      dispatch(setItemsQuerying(false));
      dispatch(getQueriedItemsFailure('An error occurred while fetching business items.'));
    }
  };
};